"use client";

import { analyticEvents, handlePostAnalytics } from "@/apiUtils/analyticsUtils";
import { analyticEventSources, analyticEventTypes } from "@/apiUtils/constants";
import {
  PromotionalBannerItem,
  PromoBannerGroupsData,
  TranslationData,
} from "@/common/lib/types";
import PromoBannerGroups from "./PromoBannerGroups";
import useDebounceCallback from "@/hooks/useDebounceCallback";
import { useRef } from "react";

interface PromoBannerGroup {
  desktop: Array<any>;
  mobile: Array<any>;
}

interface PromoBannerGroupsViewProps {
  promotionalBannerGroupsData: PromoBannerGroupsData;
  locale: string;
  translations?: TranslationData;
}

const PromoBannerGroupsView = ({
  promotionalBannerGroupsData,
  locale,
  translations,
}: PromoBannerGroupsViewProps) => {
  const groups = promotionalBannerGroupsData?.groups;
  const gaDataRef = useRef<PromotionalBannerItem[]>([]);
  const debounce = useDebounceCallback(99);

  const handlePromotionClick = (data: PromotionalBannerItem) => {
    handlePostAnalytics({
      eventType: analyticEventTypes.ACTIONS,
      data: {
        target: analyticEvents.SELECT_PROMOTION,
        promotions: [data],
        source: analyticEventSources.PROMOTIONAL_BANNER,
      },
    });
  };

  const triggerAnalyticsPromotionImpression = (visiblePromotionData: PromotionalBannerItem[]) => {
    handlePostAnalytics({
      eventType: analyticEventTypes.DETAILS,
      data: {
        target: analyticEvents.VIEW_PROMOTION,
        promotions: visiblePromotionData,
        source: analyticEventSources.PROMOTIONAL_BANNER,
      },
    });
  };

  const gaTriggerHandler = () => {
    triggerAnalyticsPromotionImpression(gaDataRef.current);
    gaDataRef.current = [];
  };

  const handleVisible = (isVisible: boolean, data: PromotionalBannerItem) => {
    if (isVisible) {
      gaDataRef.current.push(data);
      debounce(gaTriggerHandler);
    }
  };

  return (
    <PromoBannerGroups
      groups={groups as PromoBannerGroup[]}
      locale={locale}
      translations={translations}
      handleOnVisible={handleVisible}
      handleClick={handlePromotionClick}
    />
  );
};

export default PromoBannerGroupsView;
